import React, { Fragment, useEffect, useState } from "react";
import { Button, Col, Label, Row } from "reactstrap";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import { mapSearchAutoSuggestion } from "../../../utils/mapper";
import { getUsersApi } from "../../../services/manage-user/user";

const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: 50,
    border: "none",
  }),
};

const customMultiStyles = {
  ...customStyles,

  multiValue: (base) => ({
    ...base,
    backgroundColor: "#656E78",
    color: "#fff",
    // borderRadius: "4px",
    padding: "2px 4px",
  }),

  multiValueLabel: (base) => ({
    ...base,
    color: "#fff",
    fontWeight: 500,
  }),

  multiValueRemove: (base) => ({
    ...base,
    color: "#fff",
    ":hover": {
      backgroundColor: "#333",
      color: "#fff",
    },
  }),
};

function ApproveDeclineForm({ partnerState, onHandleSubmit, changeInvoiceLoading }) {
  const [reasons, setReasons] = useState([]);
  const [status, setStatus] = useState(0);
  const [selectReason, setSelectedReason] = useState(null);
  const [selectUser, setSelectedUser] = useState(null);

  useEffect(() => {
    if (partnerState && (partnerState.appDecDialog.isApprove === true || partnerState.appDecDialog.isApprove === false)) {
      if (partnerState.appDecDialog.isApprove === true) {
        setStatus(1);
        setReasons(partnerState.reconciliationSettings.approveReasons);
      } else if (partnerState.appDecDialog.isApprove === false) {
        setStatus(2);
        setReasons(partnerState.reconciliationSettings.declineReasons);
      }
    }
  }, [partnerState]);

  return (
    <Fragment>
      <div style={{ padding: "20px" }}>
        <Row>
          <Col>
            <Label className="col-form-label">Reason <span style={{color : 'red'}}>*</span></Label>
            <Select
              placeholder={status === 1 ? "Approve Reason" :"Decline Reason"}
              className="select2-filter"
              getOptionLabel={(option) => option.name}
              getOptionValue={(option) => option.id}
              isClearable
              options={reasons}
              styles={customMultiStyles}
              onChange={(selected) => {
                setSelectedReason(selected);
              }}
              components={{
                IndicatorSeparator: () => null,
              }}
            />
          </Col>
          <Col>
            <Col>
              <Label className="col-form-label">{status === 1 ? "Approve By" :"Decline By"} <span style={{color : 'red'}}>*</span></Label>
              <Select
                placeholder={status === 1 ? "Approve By" :"Decline By"}
                className="select2-filter"
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                isClearable
                options={partnerState.reconciliationSettings.users}
                styles={customMultiStyles}
                onChange={(e) => {
                  setSelectedUser(e ? e : null);
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
              />
            </Col>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col sm={12} className="d-flex justify-content-end">
            <Button
              color="success"
              // disabled={}
              onClick={(e) => {
                e.stopPropagation();
                const data = {
                  status,
                  selectReason,
                  selectUser,
                };
                if (!selectReason || !selectUser) return true;

                onHandleSubmit(data);
              }}
              disabled={changeInvoiceLoading}
            >
              {status === 1 ? (
                changeInvoiceLoading ? (
                  <>
                    {" "}
                    <i className="fa fa-spinner fa-spin fa-lg spinner mr-1" /> Approve
                  </>
                ) : (
                  "Approve"
                )
              ) : status === 2 ? (
                changeInvoiceLoading ? (
                  <>
                    {" "}
                    <i className="fa fa-spinner fa-spin fa-lg spinner mr-1" /> Declined
                  </>
                ) : (
                  "Declined"
                )
              ) : (
                ""
              )}
            </Button>
          </Col>
        </Row>
      </div>
    </Fragment>
  );
}

export default ApproveDeclineForm;
